import { Link, Text } from '@blueprint/ui';
import React, { FC } from 'react';
import { getTranslator } from '../../../shared/i18n/getTranslator';
import { Container, DiscoverHeader } from './DiscoverMore.styles';
import { MAIN_SITE_LINK } from '../../../constants';
import searchTranslations from 'public/locales/en/search.json';
import { Interpolate } from '../../../shared/i18n/Interpolate';

type Props = {
    searchArea: string | null;
    housePricesUri: string | null;
    findAgentsUri: string | null;
};

const t = getTranslator(searchTranslations);

export const DiscoverMore: FC<Props> = ({
    searchArea,
    housePricesUri,
    findAgentsUri
}) => {
    return searchArea && housePricesUri && findAgentsUri ? (
        <Container>
            <DiscoverHeader size="7">
                {t('seo.discoverMore.header')}
            </DiscoverHeader>
            <Text size="8">
                <Interpolate
                    template={t('seo.discoverMore.explore')}
                    values={{
                        housePriceLink: (
                            <Link
                                key="prices"
                                href={`${MAIN_SITE_LINK}${housePricesUri}`}
                                data-testid="house-prices-link"
                            >
                                {t('seo.discoverMore.exploreHousePriceLink', {
                                    location: searchArea
                                })}
                            </Link>
                        ),
                        findAgentsLink: (
                            <Link
                                key="agents"
                                href={`${MAIN_SITE_LINK}${findAgentsUri}`}
                                data-testid="find-agents-link"
                            >
                                {t('seo.discoverMore.exploreFindAgentsLink', {
                                    location: searchArea
                                })}
                            </Link>
                        )
                    }}
                />
            </Text>
        </Container>
    ) : null;
};
